import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosInstance } from '../../utils/axiosInstance';
import QRCode from 'react-qr-code';
import { v4 as uuidv4 } from 'uuid';
import { socket } from '../../config';
import Cookies from 'js-cookie';

interface UserDetails {
	phoneNumber?: string;
	username?: string;
	uid?: string;
	displayName?: string;
}

interface QrCodeData {
	userDetails: UserDetails;
	token: string;
	collegeId: string;
}

function Login() {
	const [isSendOtp, setSendOtp] = useState<number>(0);
	const [isLoading, setIsLoading] = useState(false);
	const [otp, setOtp] = useState(['', '', '', '', '', '']);
	const [confirm, setConfirm] = useState<any>();
	const [filledData, setFilledData] = useState({ mobile: '' });
	const [collegeData, setCollegeData] = useState<any>();
	const { collegeList, setCollegeId } = useContext(FirebaseContext);
	const history = useHistory();
	const [qrCode, setQRCode] = useState(`NECTTOS_QR_${uuidv4()}`);

	const inputRefs: any = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

	const handleInputChange = (index: any, e: any) => {
		if (e.target.value && index < inputRefs.length - 1) {
			inputRefs[index + 1]?.current?.focus();
		}
		let temp = [...otp];
		temp[index] = e.target.value;
		setOtp([...temp]);
		if (index === 5) {
			verfiyOtp(temp.join(''));
		}
	};

	useEffect(() => {
		const token = Cookies.get('userToken');
		if (token) {
			const user = localStorage.getItem('userDetails');
			if (user) {
				if (collegeList?.length === 1) history.push('/app');
				else window.location.href = "/college-list";
			}
		}
	}, []);

	useEffect(() => {
		const handleQrCode = ({ userDetails, token, collegeId }: QrCodeData) => {
			Cookies.set('userToken', token, { expires: 365 * 10, sameSite: 'strict', secure: true });
			localStorage.setItem(
				'userDetails',
				JSON.stringify({
					phoneNumber: userDetails?.phoneNumber,
					username: userDetails?.username,
					displayName: userDetails?.displayName,
					uid: userDetails?.uid,
				}),
			);
			localStorage.setItem('collegeId', JSON.stringify(collegeId));
			setCollegeId(collegeId);
			toast.success('Login Successfully');
			window.location.reload();
		};
		socket.on(qrCode, handleQrCode);
		return () => {
			socket.off(qrCode, handleQrCode);
			socket.disconnect();
		};
	}, []);

	const verfiyOtp = async (otp: string) => {
		setIsLoading(true);
		const instance = await getAxiosInstance();
		instance
			.post(`/auth/verify-otp`, { token: confirm, otp })
			.then(async (response) => {
				Cookies.set('userToken', response.data.jwtToken, { expires: 365 * 10, sameSite: 'strict', secure: true });

				console.log(response.data);

				localStorage.setItem(
					'userDetails',
					JSON.stringify({
						phoneNumber: response.data.phoneNumber,
						username: response.data.userName,
						displayName: response.data.userName,
						uid: response.data.uid,
					}),
				);
				setIsLoading(false);
				if (collegeList?.length === 1) history.push('/app');
				else window.location.href = "/college-list";
			})
			.catch((err) => {
				console.log(err);
				toast.error(err.message);
				setIsLoading(false);
			});
	};

	const login = async () => {
		const instance = await getAxiosInstance();
		if (filledData.mobile) {
			instance
				.post(`/auth/sent-otp`, {
					phoneNumber: `+91${filledData.mobile}`,
				})
				.then((response) => {
					const elem = document.getElementById('loginForm');
					if (elem) {
						elem.style.height = '400px';
						const otp = document.getElementById('otp');
						if (otp) {
							otp.style.display = 'flex';
						}
					}
					let second = 300;
					let intervalId = setInterval(() => {
						second = second - 1;
						setSendOtp(second);
						if (second <= 0) {
							clearInterval(intervalId);
						}
					}, 1000);
					setConfirm(response.data.token);
					console.log(response);
					toast.success('OTP Sended');
				})
				.catch((err) => {
					toast.error('Your Not authorized ');
				});
		} else {
			toast.error('Please give Phone number');
		}
	};

	return (
		<div className='relative flex flex-col sm:flex-row items-center justify-center w-full sm:w-auto h-[600px] p-6 bg-gradient-to-r from-blue-500 to-purple-600 rounded-3xl shadow-xl' style={{ backdropFilter: 'blur(12px)' }}>
			<h3 className='absolute text-white top-4 w-full text-center text-xl sm:text-3xl font-bold drop-shadow-lg'>Welcome to {collegeData?.collegeName || 'Necttos'}</h3>
			<div className='flex flex-col items-center justify-center w-[260px] sm:w-[220px] mr-6'>
				<h3 className='text-white text-lg sm:text-2xl font-semibold mb-4'>Login with QR Code</h3>
				<QRCode size={256} className='w-[220px] h-[220px] border border-white rounded-lg shadow-lg' value={qrCode} viewBox={`0 0 256 256`} />
			</div>
			<div id='loginForm' className='flex flex-col w-full sm:w-[500px] bg-white/10 p-6 rounded-3xl shadow-xl transition-all duration-200' style={{ backdropFilter: 'blur(12px)' }}>
				<div className='mb-6 text-center'>
					<h1 className='text-white text-xl sm:text-3xl font-bold'>Login</h1>
					<p className='text-gray-200 mt-2 text-sm sm:text-base'>Your data is securely protected with us.</p>
				</div>
				<div>
					<label htmlFor='' className='flex items-center justify-between border border-white/50 bg-white/20 p-3 rounded-lg mb-4 shadow-lg focus-within:ring-2 focus-within:ring-blue-300'>
						<input type='text' value={filledData.mobile} placeholder='Phone Number' onChange={(e) => setFilledData({ ...filledData, mobile: e.target.value })} className='w-full bg-transparent text-white outline-none placeholder-white/70' />
						<svg style={{ color: 'white' }} xmlns='http://www.w3.org/2000/svg' width={20} height={20} fill='currentColor' className='ml-2' viewBox='0 0 16 16'>
							<path fillRule='evenodd' d='M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z' />
						</svg>
					</label>
					<button
						className={`w-full text-center text-white text-sm sm:text-base py-2 px-4 rounded-lg transition-all ${isSendOtp < 1 ? 'bg-blue-500 hover:bg-blue-600 cursor-pointer' : 'bg-gray-500 cursor-not-allowed'}`}
						onClick={() => {
							if (isSendOtp < 1) {
								login();
							}
						}}>
						Send OTP
					</button>
					<label htmlFor='' id='otp' className={`flex items-center justify-between transition-all duration-150 overflow-hidden mt-6 ${isSendOtp > 0 ? 'visible' : 'hidden'}`}>
						<div className='flex gap-2'>
							{inputRefs.map((inputRef: any, index: any) => (
								<input
									key={index}
									type='text'
									maxLength={1}
									value={otp[index]}
									onChange={(e) => handleInputChange(index, e)}
									onKeyDown={(e) => {
										if (e.key === 'Backspace' && index > 0) {
											inputRefs[index - 1]?.current?.focus();
										}
									}}
									ref={inputRef}
									className='w-12 h-12 text-center bg-white/10 border border-white rounded-lg text-white placeholder:text-white'
								/>
							))}
						</div>
						<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='20' height='20' fill='#ffffff'>
							<g>
								<path fill='none' d='M0 0h24v24H0z' />
								<path d='M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1zm-7 7.732V18h2v-2.268a2 2 0 1 0-2 0zM16 8V7a4 4 0 1 0-8 0v1h8z' />
							</g>
						</svg>
					</label>
					{isSendOtp > 0 && (
						<p className='text-white mt-4 text-center text-sm sm:text-base'>
							OTP sent! Expires in: <span className='font-semibold'>{isSendOtp}s</span>
						</p>
					)}
				</div>
			</div>
		</div>
	);
}

export default Login;
